import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=6f9b88d2&scoped=true&lang=pug"
import script from "./Summary.js?vue&type=script&lang=js&external"
export * from "./Summary.js?vue&type=script&lang=js&external"
import style0 from "./Summary.vue?vue&type=style&index=0&id=6f9b88d2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9b88d2",
  null
  
)

export default component.exports